export default "__VITE_ASSET__OEAVy2gY__"